import { StepId } from './assistant-steps';

export const JUMP_TO_CONTACTFORM =
  'JUMP_TO_' + StepId.ASSISTANT_SUBMIT.toUpperCase();
